'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ListGroupItem = require('react-bootstrap/lib/ListGroupItem');

var _ListGroupItem2 = _interopRequireDefault(_ListGroupItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ListGroupItem2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@sketchpixy/rubix/lib/ListGroupItem.js
 ** module id = ./node_modules/@sketchpixy/rubix/lib/ListGroupItem.js
 ** module chunks = 0
 **/